import React, { useState, useEffect } from 'react'
import { isNilOrEmpty, useDebounce } from 'packages/core'
import { Box, Paper } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'
import { ThresholdSearchInput } from 'packages/eid-ui'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#ffffff !important',
        boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.1)',
        border: 'solid 1px #ebebed',
        borderRadius: '5px',
        height: '40px',
    },

    outlined: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#ffffff !important',
        boxShadow: 'none !important',
        border: 'solid 1px #d8d8dd',
        borderRadius: '3px',
        fontSize: '13px',
        paddingLeft: '10px',
        '&  .MuiInputBase-input': {
            fontSize: '13px !important',
        },
        '&:hover': {
            border: '1px solid #307fc1',
        },

        '&:focus-within': {
            border: '1px solid #307fc1',
            boxShadow: '0 4px 8px 0 rgba(48, 127, 193, 0.33)',
        },
    },

    icon: {
        margin: '0px 6px',
    },

    clearIcon: {
        margin: '0px 10px 3px auto',
        '&:hover': {
            cursor: 'pointer',
        },
    },
})

const Search = (props) => {
    const { handleSearch, handleClear, placeholder, value, outlined, customStyle } = props
    const { t } = useTranslation()
    const [searchKey, setSearchKey] = useState(value)

    useEffect(() => {
        if (value !== searchKey) {
            setSearchKey(value)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])

    const handleChange = (eventOrValue) => {
        const value = eventOrValue?.target?.value ?? eventOrValue // Safely access the value
        setSearchKey(value)
    }

    const handleClearSearch = () => {
        setSearchKey('')
        handleClear('')
    }
    const debouncedValue = useDebounce(searchKey)

    useEffect(() => {
        handleSearch(debouncedValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue])

    const classes = useStyles()

    return (
        <Paper className={!outlined ? classes.root : classes.outlined} sx={customStyle}>
            <Icon name="Search" color="#D8D8DD" className={classes.icon} />

            <Box position="relative">
                <ThresholdSearchInput
                    value={searchKey}
                    handleSearch={handleChange}
                    placeholder={placeholder ?? t('Search')}
                    sx={{
                        '& > input': {
                            width: '100%',
                            height: '10px',
                            border: 'none',
                            boxShadow: 'none !important',
                        }
                    }}
                    sxNotify={{ position: 'absolute', top: '-33px' }}
                />
            </Box>

            {!isNilOrEmpty(searchKey) && (
                <Icon
                    name="Close"
                    color="#D8D8DD"
                    className={classes.clearIcon}
                    onClick={handleClearSearch}
                />
            )}
        </Paper>
    )
}

export default Search
